import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _this = this;

import * as tslib_1 from "tslib";
import { createContext, useMemo } from 'react';
import constate from 'constate';
import { StorageProvider } from './storageProvider';
export var StorageContext = createContext({
  save: function save(path, value) {
    return Promise.resolve(value);
  },
  update: function update(path, value) {
    return Promise.resolve(value);
  },
  get: function get() {
    return Promise.resolve(null);
  },
  delete: function _delete() {
    return Promise.resolve();
  },
  log: function log(value) {
    return Promise.resolve(false);
  },
  config: {
    kind: 'http',
    url: 'fakeurl',
    authToken: 'AUTHTOKEN'
  },
  setConfig: function setConfig() {
    return Promise.resolve();
  }
});
export function buildStore(config) {
  return new StorageProvider(config);
}
export var TokenStorageKey = 'usertoken';
export var TokenFromStorage = function TokenFromStorage(storage) {
  return storage.get(TokenStorageKey).then(function (val) {
    return !val ? undefined : typeof val === 'string' ? val : val.value;
  });
};
export var SaveTokenInStorage = function SaveTokenInStorage(storage, value) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return storage.save(TokenStorageKey, value);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
export var ExpireTokenInStorage = function ExpireTokenInStorage(storage) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return storage.save(TokenStorageKey, undefined);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};
export var SyncTabStorageKey = 'localTabSync';
export var SyncTabFromStorage = function SyncTabFromStorage(storage) {
  return storage.get(SyncTabStorageKey).then(function (val) {
    return !val ? undefined : typeof val === 'string' ? val : val.value;
  });
};
export var SaveSyncTabInStorage = function SaveSyncTabInStorage(storage, value) {
  return tslib_1.__awaiter(_this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return storage.save(SyncTabStorageKey, value);

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
export function useStorageContext(config) {
  return useMemo(function () {
    return new StorageProvider(config);
  }, [config]);
}
export var useStorage = constate(useStorageContext);
export var useLocalStorage = constate(function (args) {
  return useStorageContext(Object.assign({
    kind: 'localstorage'
  }, args));
});